import { render, staticRenderFns } from "./PaymentLock.vue?vue&type=template&id=6815135f&"
var script = {}
import style0 from "./PaymentLock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentLock.vue
// module id = null
// module chunks = 